(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vnm-dashboard-cart-toast"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.querySelector('[data-vnm-dashboard-cart-toast]')) return;
    if (document.documentElement.dataset.vnmDashboardCartControlsInitialized === 'true') return;

    document.documentElement.dataset.vnmDashboardCartControlsInitialized = 'true';
    var hideTimer;
    var cartSyncTimer;
    var cartSyncInFlight = false;

    function getToast() {
      return document.querySelector('[data-vnm-dashboard-cart-toast]');
    }

    function hideToast() {
      var toast = getToast();
      if (!toast) return;

      toast.classList.remove('is-visible');
      toast.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (!toast.classList.contains('is-visible')) toast.hidden = true;
      }, 220);
    }

    function showToast() {
      var toast = getToast();
      if (!toast) return;

      window.clearTimeout(hideTimer);
      positionToast();
      toast.hidden = false;
      toast.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () {
        toast.classList.add('is-visible');
      });
      hideTimer = window.setTimeout(hideToast, 4200);
    }

    function setToastProduct(form) {
      var toast = getToast();
      if (!toast) return;

      var card = form.closest('.vnm-dashboard__reorder-card');
      var productTitle = card ? card.querySelector('h2, h3') : null;
      var toastProduct = toast.querySelector('[data-vnm-dashboard-cart-toast-product]');
      if (!toastProduct) return;

      toastProduct.textContent = productTitle ? productTitle.textContent.trim() : '';
      toastProduct.hidden = !toastProduct.textContent;
    }

    function refreshQikify() {
      try {
        if (typeof window.STICKY_CART_UPDATE === 'function') window.STICKY_CART_UPDATE();
      } catch (error) {
        return;
      }
    }

    function getDashboardForm(target) {
      if (!target || !target.closest) return null;

      var form = target.closest('form.js-product-form');
      if (!form || !form.closest('product-form[data-vnm-no-auto-cart-drawer]')) return null;

      return form;
    }

    function setFormError(form, message) {
      var formError = form.closest('product-form').querySelector('.js-form-error');
      if (!formError) return;

      formError.hidden = !message;
      formError.textContent = message || '';
    }

    function updateHeaderCart(cart) {
      var cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      var total = Number(cart.total_price || 0) / 100;
      var totalNumber = total.toFixed(2);
      var formattedTotal = totalNumber;

      if (window.Intl && window.Intl.NumberFormat && cart.currency) {
        formattedTotal = new window.Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency: cart.currency
        }).format(total);
      }

      var headerTotal = cartIconBubble.querySelector('.header__cart-total');
      var headerTotalNumber = cartIconBubble.querySelector('.header__cart-total-number');
      var accessibleTotal = cartIconBubble.querySelector('.visually-hidden');

      if (headerTotal) headerTotal.setAttribute('aria-label', formattedTotal + ', ' + cart.item_count);
      if (headerTotalNumber) headerTotalNumber.textContent = totalNumber;
      if (accessibleTotal) accessibleTotal.textContent = formattedTotal + ', ' + cart.item_count;
    }

    function positionToast() {
      var toast = getToast();
      var header = document.querySelector('store-header.header');
      if (!toast || !header) return;

      var headerBottom = Math.ceil(header.getBoundingClientRect().bottom);
      toast.style.setProperty('--vnm-dashboard-toast-top', Math.max(headerBottom + 8, 8) + 'px');
    }

    function getFreshCartUrl(cartJsUrl) {
      return cartJsUrl + (cartJsUrl.indexOf('?') === -1 ? '?' : '&') + '_=' + Date.now();
    }

    async function syncHeaderCart() {
      var toast = getToast();
      if (!toast || cartSyncInFlight) return;

      var cartJsUrl = toast.dataset.cartJsUrl;
      if (!cartJsUrl) return;

      cartSyncInFlight = true;

      try {
        var response = await fetch(getFreshCartUrl(cartJsUrl), {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error(response.status);

        updateHeaderCart(await response.json());
      } catch (error) {
        return;
      } finally {
        cartSyncInFlight = false;
      }
    }

    function scheduleHeaderCartSync(delay) {
      window.clearTimeout(cartSyncTimer);
      cartSyncTimer = window.setTimeout(syncHeaderCart, typeof delay === 'number' ? delay : 250);
    }

    function observeQikifyCart() {
      var qikifyCart = document.getElementById('qikify-stickycart-v2-app');
      if (!qikifyCart) return false;
      if (qikifyCart.dataset.vnmDashboardCartObserved === 'true') return true;

      qikifyCart.dataset.vnmDashboardCartObserved = 'true';
      new MutationObserver(function () {
        scheduleHeaderCartSync(250);
      }).observe(qikifyCart, { childList: true, characterData: true, subtree: true });

      qikifyCart.addEventListener('click', function () {
        scheduleHeaderCartSync(700);
      });

      return true;
    }

    function initializeQikifyCartSync() {
      if (observeQikifyCart()) return;

      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (observeQikifyCart() || attempts === 20) window.clearInterval(timer);
      }, 500);
    }

    async function addDashboardItem(form) {
      if (form.dataset.vnmDashboardCartSubmitting === 'true') return;

      var toast = getToast();
      if (!toast) return;

      var button = form.querySelector('[name="add"]');
      var wasDisabled = button ? button.disabled : false;
      var cartAddUrl = toast.dataset.cartAddUrl;
      var cartJsUrl = toast.dataset.cartJsUrl;

      if (!cartAddUrl || !cartJsUrl) return;

      form.dataset.vnmDashboardCartSubmitting = 'true';
      setFormError(form, '');

      if (button) {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-pending');
      }

      try {
        var silentCartAddUrl = cartAddUrl + (cartAddUrl.indexOf('?') === -1 ? '?' : '&') + 'sc-silently-change-cart=true';
        var response = await fetch(silentCartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new FormData(form)
        });
        var data = await response.json();

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || response.status);
        }

        var cartResponse = await fetch(getFreshCartUrl(cartJsUrl), {
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!cartResponse.ok) throw new Error(cartResponse.status);

        var cart = await cartResponse.json();
        updateHeaderCart(cart);
        refreshQikify();
        setToastProduct(form);
        showToast();
      } catch (error) {
        setFormError(form, error.message || '');
      } finally {
        delete form.dataset.vnmDashboardCartSubmitting;

        if (button) {
          button.disabled = wasDisabled;
          button.toggleAttribute('aria-disabled', wasDisabled);
          button.classList.remove('is-pending');
        }
      }
    }

    window.addEventListener('click', function (event) {
      var form = getDashboardForm(event.target);
      if (!form || !event.target.closest('[name="add"]')) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addDashboardItem(form);
    }, true);

    window.addEventListener('submit', function (event) {
      var form = getDashboardForm(event.target);
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      addDashboardItem(form);
    }, true);

    document.addEventListener('click', function (event) {
      var closeButton = event.target.closest('[data-vnm-dashboard-cart-toast-close]');
      if (!closeButton) return;
      hideToast();
    });

    document.addEventListener('on:cart:add', function () {
      scheduleHeaderCartSync(250);
    });

    document.addEventListener('on:line-item:change', function () {
      scheduleHeaderCartSync(250);
    });

    window.addEventListener('focus', function () {
      positionToast();
      scheduleHeaderCartSync(0);
    });

    window.addEventListener('resize', positionToast);

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) scheduleHeaderCartSync(0);
    });

    initializeQikifyCartSync();
    scheduleHeaderCartSync(0);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vnm-whatsapp-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    const launcher = document.querySelector('[data-vnm-whatsapp-chat]');
    if (!launcher) return;
    let frame = 0;
    const barSelector = '.vnm-dashboard__bottom-nav, .qsc2-stickybar, sticky-atc-panel, .sticky-atc-panel, [data-vnm-sticky-bar]';
    const bars = new Set();
    const resizeObserver = new ResizeObserver(() => schedule());
    const sessionKey = 'vnm_whatsapp_chat_label_seen_v1';
    let labelPending = launcher.dataset.vnmChatLabelEligible === 'true';
    let labelTimer = 0;
    try {
      labelPending = labelPending && sessionStorage.getItem(sessionKey) !== '1';
    } catch {
      labelPending = false;
    }
    const dismissLabel = () => {
      if (labelPending) {
        try { sessionStorage.setItem(sessionKey, '1'); } catch {}
      }
      labelPending = false;
      clearTimeout(labelTimer);
      labelTimer = 0;
      launcher.classList.remove('is-label-visible');
    };
    const revealLabel = () => {
      if (!labelPending || document.hidden || launcher.hidden || !visible(launcher)) return;
      try { sessionStorage.setItem(sessionKey, '1'); } catch { labelPending = false; return; }
      labelPending = false;
      launcher.classList.add('is-label-visible');
      labelTimer = setTimeout(dismissLabel, 5000);
    };
    const visible = (element) => {
      if (!element || element.hidden) return false;
      const style = getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 &&
        rect.width > 0 && rect.height > 0 && rect.top < innerHeight && rect.bottom > 0 &&
        rect.left < innerWidth && rect.right > 0;
    };
    const update = () => {
      frame = 0;
      const mobile = matchMedia('(max-width: 768.98px)').matches;
      let obstacle = 0;
      document.querySelectorAll(barSelector).forEach((bar) => {
        if (!bars.has(bar)) { bars.add(bar); resizeObserver.observe(bar); }
        if (!visible(bar)) return;
        const style = getComputedStyle(bar);
        const rect = bar.getBoundingClientRect();
        if (style.position === 'fixed' && rect.top >= innerHeight / 2 && rect.bottom >= innerHeight - 50) {
          obstacle = Math.max(obstacle, innerHeight - rect.top);
        }
      });
      const offset = `${Math.ceil(obstacle)}px`;
      if (launcher.style.getPropertyValue('--vnm-chat-obstacle') !== offset) {
        launcher.style.setProperty('--vnm-chat-obstacle', offset);
      }
      const keyboard = mobile && window.visualViewport && innerHeight - visualViewport.height > 150 &&
        /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '');
      const modal = document.querySelector('dialog[open], [aria-modal="true"][open], .drawer.is-open, .drawer.is-active, .qsc2-drawer--open');
      const hidden = Boolean(keyboard || visible(modal));
      if (launcher.hidden !== hidden) launcher.hidden = hidden;
      if (hidden && launcher.classList.contains('is-label-visible')) dismissLabel();
      if (!hidden) revealLabel();
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const mutationObserver = new MutationObserver((records) => {
      if (records.some((record) => record.target !== launcher && !launcher.contains(record.target))) schedule();
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden'] });
    addEventListener('resize', schedule, { passive: true });
    addEventListener('scroll', () => { dismissLabel(); schedule(); }, { passive: true });
    addEventListener('pagehide', dismissLabel);
    addEventListener('pageshow', schedule);
    addEventListener('focusin', schedule);
    addEventListener('focusout', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:unload', schedule);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) dismissLabel();
      else schedule();
    });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

})();
